import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgKcp({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3.897 11.715l2.59-2.282 1.49.039-2.769 2.34 1.762 3.085H5.246l-1.465-2.541-.458 2.547H2.008l.938-4.95-.561-.496h1.918l-.406 2.258z"
        fill="#006B86"
      />
      <path
        d="M12.607 9.58c-.849-.283-2.017-.463-3.22-.04-1.205.425-1.71 1.077-2.033 1.733-.417.962-.377 2.354 0 2.933.376.579 1.347.873 2.56.835 1.212-.037 1.437-.196 1.518-.333.081-.137.326-.755.326-.873-.072-.173-.326-.098-.326-.098s-.779.523-1.939.426c-.645-.108-1.047-.75-1.047-1.739 0-.988.678-1.69.94-1.909.262-.218 1.473-.518 2.75.102.28-.102.598-.968.47-1.036z"
        fill="#006B86"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.68 9.495c-.875-.086-2.08-.098-3.616-.037l.5.494-.941 4.942h1.31l.36-1.943c1.346.085 2.268-.135 2.766-.66.747-.788.935-2.669-.378-2.796zm-2.14 2.524l.31-1.686c.695-.092 1.1-.057 1.216.105.413.281-.07 1.581-.434 1.581H14.54z"
        fill="#006B86"
      />
      <path
        d="M7.526 15.889h1.46l1.91 2.368.018.02c.342.4.943.447 1.343.105l7.73-6.617a.952.952 0 00.109-1.339l-3.788-4.473a.952.952 0 00-1.34-.114L11.95 8.375h-1.69l4.28-3.55a1.786 1.786 0 012.506.223l4.096 4.857c.636.754.54 1.881-.214 2.517l-.003.002-8.177 6.872a1.786 1.786 0 01-2.511-.212l-2.71-3.195z"
        fill="url(#KCP_svg__paint0_linear)"
      />
      <defs>
        <linearGradient
          id="KCP_svg__paint0_linear"
          x1={7.526}
          y1={18.883}
          x2={21.562}
          y2={18.883}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C8D596" />
          <stop offset={1} stopColor="#139D56" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SvgKcp
